<template>
  <Toast position="top-center">
    <template #message="slotProps">
      <div class="toast">
        <img
          :src="getToastIcon(slotProps.message.severity)"
          width="18"
          alt="icon"
        />
        <p class="body-text-s medium">{{ slotProps.message.summary }}</p>
      </div>
    </template>
  </Toast>
</template>
<script setup lang="ts">
import Toast from "primevue/toast"

const getToastIcon = (severity: string) => {
  const icon = `/assets/icons/emoji/toast/${severity}.png`
  return new URL(icon, import.meta.url).toString()
}
</script>
<style lang="less">
.toast {
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
}
.p-toast-close-button {
  margin: 0 !important;
  right: 0 !important;
}
</style>
